/**
 * FiscalTags — badges de pré-requisito nos entry-points de NFS-e (card do dashboard,
 * link em Configurações). "PRO" = precisa do plano pago; "CNPJ" = precisa ser
 * MEI/ME-EPP (ter CNPJ).
 *
 * Estilo unificado: usa a MESMA pílula (`MODULE_TAG_CLASS`) de todos os selos de
 * módulo do app (PRO em Contratos/Estoque/Relatórios). Quando há mais de
 * uma tag (ex.: NFS-e para free sem CNPJ → PRO + CNPJ) elas empilham na VERTICAL.
 */
import { cn } from '@/lib/utils';
import { PRO_TAG_CLASS } from '@/components/ui/pro-tag';
import type { FiscalTag } from '@/hooks/useFiscalReadiness';

/** Pílula-padrão dos selos de módulo (fonte única de verdade do estilo). */
export const MODULE_TAG_CLASS = PRO_TAG_CLASS;

const TITLE: Record<FiscalTag, string> = {
  PRO: 'Disponível no plano PRO',
  CNPJ: 'Requer um CNPJ (MEI ou ME/EPP)',
};

export function FiscalTags({ tags, className }: { tags: FiscalTag[]; className?: string }) {
  if (!tags.length) return null;
  return (
    <span className={cn('flex flex-col items-end gap-0.5', className)}>
      {tags.map((t) => (
        <span key={t} title={TITLE[t]} className={MODULE_TAG_CLASS}>
          {t}
        </span>
      ))}
    </span>
  );
}
